import { GoabText } from '@abgov/angular-components';
import { Component, computed, inject, input, output } from '@angular/core';
import { Params, UrlTree } from '@angular/router';
import { ResponsiveService } from '../../services/responsive.service';
import { BackNavCtaComponent } from '../back-nav-cta/back-nav-cta.component';

export interface InnerPageHeaderBackCta {
  text: string;
  ariaLabel?: string;
  dataTestId?: string;
  routerLink?: string | readonly unknown[] | UrlTree;
  queryParams?: Params;
  fragment?: string;
  href?: string;
}

@Component({
  selector: 'common-inner-page-header',
  standalone: true,
  imports: [BackNavCtaComponent, GoabText],
  templateUrl: './inner-page-header.component.html',
  styleUrl: './inner-page-header.component.scss',
})
export class InnerPageHeaderComponent {
  private readonly responsive = inject(ResponsiveService);

  title = input.required<string>();
  titleId = input<string | undefined>(undefined);
  titleDataTestId = input<string | undefined>(undefined);
  applyTopOffset = input<boolean>(true);
  backCta = input<InnerPageHeaderBackCta | undefined>(undefined);

  backCtaRequested = output<void>();

  protected readonly isDesktop = this.responsive.isMdLarge;

  protected readonly titleSize = computed(() =>
    this.isDesktop() ? 'heading-l' : 'heading-m'
  );

  protected readonly topOffset = computed(() => {
    if (!this.applyTopOffset()) {
      return '0';
    }

    return this.isDesktop() ? '3rem' : '1.5rem';
  });

  protected readonly titleMarginBottom = computed(() =>
    this.isDesktop() ? '1.5rem' : '1rem'
  );

  protected readonly backCtaMarginBottom = computed(() =>
    this.isDesktop() ? '1rem' : '0.5rem'
  );

  protected onBackCtaRequested(): void {
    this.backCtaRequested.emit();
  }
}
